import { createSelector } from 'reselect'
import { immer } from 'zustand/middleware/immer'

import { StoreState } from '../store'
import { BaseFilter, createFilterSliceActions, FilterSliceActions } from './types'

export const surgerySchedulerFilters = ['location'] as const

export type SurgerySchedulerFilterType = (typeof surgerySchedulerFilters)[number]

export type SurgerySchedulerFilter = {
    type: SurgerySchedulerFilterType
} & BaseFilter

type State = {
    filters: SurgerySchedulerFilter[]
}

type Actions = {
    actions: FilterSliceActions<SurgerySchedulerFilterType>
}

export type SurgerySchedulerFilterSlice = {
    surgerySchedulerFilters: State & Actions
}

const initialState: State = {
    filters: [],
}

export const createSurgerySchedulerFilterSlice = immer<SurgerySchedulerFilterSlice>((set, get) => ({
    surgerySchedulerFilters: {
        ...initialState,
        actions: createFilterSliceActions<SurgerySchedulerFilterType, SurgerySchedulerFilter>('surgerySchedulerFilters', set, get),
    },
}))

const selectAllFilters = (state: StoreState) => state.surgerySchedulerFilters.filters

// Main selector for surgery scheduler filters. A plain selector, since memoising one that returns its input does nothing.
export const selectSurgerySchedulerFilters = selectAllFilters

// Filter specific selectors
export const selectLocationValues = createSelector(selectAllFilters, filters =>
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    filters.filter((filter: SurgerySchedulerFilter) => filter.type === 'location').map((filter: SurgerySchedulerFilter) => filter.value)
)
